<template>
  <div class="address-con after_border bgwhite">
    <div class="address-list">
      <div class="txt">北京市,市辖区,东城区</div>
      <p class="add">得到的点点滴滴</p>
      <div class="nam">的点点滴滴</div>
      <div class="mob">18900000077</div>
    </div>
    <div class="btn" @click="onGotoDetail">
      <img src="https://nginx-front.oss-cn-shanghai.aliyuncs.com/running-sys/edit.png" alt="">
    </div>
  </div>
</template>

<script>

export default {
  name: 'OrderPanel',
  components: {
  },
  props: {
    order: {
      type: Object,
      default () {
        return null
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    onGotoDetail () {
      this.$router.push('/my/address/' + 'xxxxxx' + '/detail')
    }
  }
}
</script>

<style scoped lang="scss">
.address-con:first-child {
  border-top: none;
}
.address-con {
  position: relative;
  padding-top: 25px;
  padding-bottom: 23px;
  border-top: 0.01rem solid #EBEBEB;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  .address-list {
    font-size: 0;
    padding-left: 20px;
    box-sizing: border-box;
    min-width: 350px;
    .txt {
      display: inline-block;
      font-size: 24px;
      color: #949494;
    }
    .add {
      font-size: 32px;
      color: #252B33;
      margin: 12px 0 26px;
      max-width: 440px;
      white-space: pre;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .nam {
      float: left;
      font-size: 26px;
      color: #949494;
      margin-right: 30px;
    }
    .mob {
      font-size: 26px;
      color: #949494;
    }
  }
  .btn {
      display: block;
      width: 38px;
      height:38px;
      padding: 30px;
      box-sizing: content-box;
      position: absolute;
      right: 0;
      top: calc(50% - 0.15rem);
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
  }
}
</style>
